/* unplugin-vue-components disabled */import script from "./PriceBlockConsume.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceBlockConsume.vue?vue&type=script&lang=ts&setup=true"

import "./PriceBlockConsume.vue?vue&type=style&index=0&id=12c52de8&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c52de8"]])

export default __exports__